import React from 'react';
import { Box, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { APP_NAME, ROUTES } from '../../constants';

/**
 * Vediluxe nested-V monogram (official brand mark — see /brand assets).
 */
export const GemMark: React.FC<{ size?: number }> = ({ size = 26 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M14 10 L50 88 L86 10" stroke="#2B2229" strokeWidth="7" strokeMiterlimit="8" />
    <path d="M36 10 L50 42 L64 10" stroke="#D65A88" strokeWidth="5" strokeMiterlimit="8" />
  </svg>
);

interface BrandLogoProps {
  /** Gem size in px; wordmark scales with it */
  size?: number;
  /** Render as a link to home (default true) */
  linked?: boolean;
}

/**
 * Gem mark + "Vediluxe" wordmark. The brand lockup used in header/drawer.
 */
const BrandLogo: React.FC<BrandLogoProps> = ({ size = 26, linked = true }) => {
  const content = (
    <>
      <GemMark size={size} />
      <Typography
        component="span"
        sx={{
          fontFamily: '"Playfair Display", serif',
          fontWeight: 600,
          fontSize: `${size * 0.82}px`,
          lineHeight: 1,
          color: 'text.primary',
          letterSpacing: '0.01em'
        }}
      >
        {APP_NAME}
      </Typography>
    </>
  );

  const baseSx = { display: 'inline-flex', alignItems: 'center', gap: 1, textDecoration: 'none' };

  if (!linked) {
    return <Box sx={baseSx}>{content}</Box>;
  }

  return (
    <Box component={RouterLink} to={ROUTES.HOME} sx={baseSx} aria-label={`${APP_NAME} home`}>
      {content}
    </Box>
  );
};

export default BrandLogo;
